/**
 * SilkTale 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

export const theme = {
  // 引用装饰线颜色 (基于主色 #FD9540)
  quoteColor: 'rgba(253, 149, 64, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
